import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const EmptyStateEnvelope = ({ height = 125, width = 125, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 125 125" {...props}>
    <path
      d="M116.34 71.808C116.339 64.1676 114.629 56.6242 111.333 49.7309C108.038 42.8377 103.242 36.7693 97.2965 31.9706C91.351 27.172 84.4069 23.7649 76.9734 21.999C69.5398 20.2332 61.8053 20.1534 54.337 21.7655C46.8686 23.3776 39.8556 26.6407 33.8124 31.3156C27.7691 35.9905 22.8488 41.9586 19.412 48.7824C15.9753 55.6063 14.1093 63.1127 13.9509 70.7515C13.7926 78.3902 15.3458 85.9676 18.4967 92.928H111.783C114.793 86.2941 116.347 79.0926 116.34 71.808Z"
      fill="#F5F4F4"
    />
    <path d="M14.58 92.9282H114.42" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M8.81995 92.9282H12.0199"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M116.98 92.9282H120.18"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M96.4105 104.96C96.4105 106.24 82.3305 107.392 64.8329 107.392C47.3353 107.392 33.2681 106.304 33.2681 104.96C33.2681 103.616 47.3481 102.528 64.8329 102.528C82.3177 102.528 96.4105 103.68 96.4105 104.96Z"
      fill="#F5F4F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.8339 55.667H87.1672C91.5855 55.667 95.1672 59.2487 95.1672 63.667V85.0003C95.1672 86.4731 93.9733 87.667 92.5005 87.667H49.8339"
      fill="#B56DC6"
    />
    <path
      d="M41.8339 55.667H87.1672C91.5855 55.667 95.1672 59.2487 95.1672 63.667V85.0003C95.1672 86.4731 93.9733 87.667 92.5005 87.667H49.8339"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.8339 87.667H36.5005C35.0278 87.667 33.8339 86.4731 33.8339 85.0003V63.667C33.8339 59.2487 37.4156 55.667 41.8339 55.667C46.2521 55.667 49.8339 59.2487 49.8339 63.667V87.667Z"
      fill="#FDF5FF"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M68.5 87.667V103.667" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M63.1677 87.667V103.667"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M68.5011 103.667C68.5009 105 63.1679 105 63.1677 103.667C63.1675 102.334 63.1677 87.667 63.1677 87.667H68.5011C68.5011 87.667 68.5013 102.334 68.5011 103.667Z"
      fill="#FDF5FF"
      stroke="#6A266D"
    />
    <path
      d="M39.1677 82.334H44.5011"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M55.1677 61L63.1677 61L55.1677 61Z"
      fill="#E6FBFF"
    />
    <path
      d="M55.1677 61L63.1677 61"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M68.5 61L68.5 69L63.1667 69L63.1667 61L68.5 61Z"
      fill="#FDF5FF"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M77.541 44.7058C78.8955 45.5549 80.4444 46.044 82.041 46.1268C86.379 46.4598 88.041 45.4578 88.673 44.7538C88.7831 44.6329 88.827 44.4658 88.7908 44.3063C88.7545 44.1469 88.6425 44.0152 88.491 43.9538C86.904 43.1835 85.4109 42.2333 84.041 41.1218C83.704 40.8678 83.168 40.4398 82.702 40.0688C82.5662 39.961 82.4959 39.7906 82.5163 39.6184C82.5367 39.4463 82.6448 39.2969 82.802 39.2238C86.152 37.6738 88.312 34.5968 88.941 30.3338C88.9664 30.1617 88.9006 29.9888 88.7671 29.8772C88.6337 29.7656 88.4518 29.7314 88.287 29.7868C86.562 30.3648 82.433 31.8598 82.038 33.0428C81.667 34.1568 80.744 36.3428 80.293 37.4008C80.2322 37.5425 80.1094 37.6481 79.9603 37.6872C79.8112 37.7263 79.6524 37.6944 79.53 37.6008C78.2333 36.454 76.6995 35.6075 75.038 35.1218C74.181 34.9015 73.2703 35.0992 72.5818 35.6551C71.8933 36.211 71.5081 37.0596 71.543 37.9438C71.5362 38.0548 71.4925 38.1604 71.419 38.2438C71.0952 38.588 70.9144 39.0423 70.913 39.5148C70.9123 39.6708 70.9844 39.8181 71.108 39.9132C71.2315 40.0083 71.3924 40.0404 71.543 39.9998L73.043 39.6248"
      fill="#FDF5FF"
    />
    <path
      d="M77.541 44.7058C78.8955 45.5549 80.4444 46.044 82.041 46.1268C86.379 46.4598 88.041 45.4578 88.673 44.7538C88.7831 44.6329 88.827 44.4658 88.7908 44.3063C88.7545 44.1469 88.6425 44.0152 88.491 43.9538C86.904 43.1835 85.4109 42.2333 84.041 41.1218C83.704 40.8678 83.168 40.4398 82.702 40.0688C82.5662 39.961 82.4959 39.7906 82.5163 39.6184C82.5367 39.4463 82.6448 39.2969 82.802 39.2238C86.152 37.6738 88.312 34.5968 88.941 30.3338C88.9664 30.1617 88.9006 29.9888 88.7671 29.8772C88.6337 29.7656 88.4518 29.7314 88.287 29.7868C86.562 30.3648 82.433 31.8598 82.038 33.0428C81.667 34.1568 80.744 36.3428 80.293 37.4008C80.2321 37.5425 80.1094 37.6481 79.9603 37.6872C79.8112 37.7263 79.6524 37.6944 79.53 37.6008C78.2333 36.454 76.6995 35.6075 75.038 35.1218C74.181 34.9015 73.2703 35.0992 72.5818 35.6551C71.8933 36.211 71.5081 37.0596 71.543 37.9438C71.5362 38.0548 71.4925 38.1604 71.419 38.2438C71.0952 38.588 70.9144 39.0423 70.913 39.5148C70.9123 39.6708 70.9844 39.8181 71.108 39.9132C71.2315 40.0083 71.3924 40.0404 71.543 39.9998L73.043 39.6248L77.541 44.7058Z"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M74.3001 37.127C74.4381 37.127 74.5501 37.2389 74.5501 37.377C74.5501 37.515 74.4381 37.627 74.3001 37.627C74.162 37.627 74.0501 37.515 74.0501 37.377C74.0498 37.3106 74.076 37.2468 74.123 37.1999C74.1699 37.1529 74.2337 37.1267 74.3001 37.127"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M77.9398 36.3724C77.9398 36.3724 77.4398 32.3724 77.4398 30.3724C77.4398 29.2444 79.4188 26.9864 80.4008 25.9344C80.5203 25.8066 80.6978 25.7506 80.8689 25.7866C81.04 25.8226 81.1799 25.9454 81.2378 26.1104C81.7066 27.4822 82.3993 30.8745 82.3939 32.3242"
      fill="#FDF5FF"
    />
    <path
      d="M77.9398 36.3724C77.9398 36.3724 77.4398 32.3724 77.4398 30.3724C77.4398 29.2444 79.4188 26.9864 80.4008 25.9344C80.5203 25.8066 80.6978 25.7506 80.8689 25.7866C81.04 25.8226 81.1799 25.9454 81.2378 26.1104C81.7066 27.4822 82.3993 30.8745 82.3939 32.3242L80.0004 37.5L77.9398 36.3724Z"
      fill="#FDF5FF"
    />
    <path
      d="M77.9398 36.3724C77.9398 36.3724 77.4398 32.3724 77.4398 30.3724C77.4398 29.2444 79.4188 26.9864 80.4008 25.9344C80.5203 25.8066 80.6978 25.7506 80.8689 25.7866C81.04 25.8226 81.1799 25.9454 81.2378 26.1104C81.7066 27.4822 82.3993 30.8745 82.3939 32.3242L80.0004 37.5L77.9398 36.3724Z"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M82.8091 46.1929L84.0461 48.0479"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M85.715 46.0513L87.046 48.0483"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M74.546 40.627L77.046 41.127L74.546 46.627L66.046 44.627L68.546 39.127L70.971 39.733"
      fill="#E6FBFF"
    />
    <path
      d="M74.546 40.627L77.046 41.127L74.546 46.627L66.046 44.627L68.546 39.127L70.971 39.733L74.546 40.627Z"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M68.546 39.127L71.046 43.127L77.046 41.127"
      fill="#E6FBFF"
    />
    <path
      d="M68.546 39.127L71.046 43.127L77.046 41.127"
      stroke="#6A266D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
